module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-top-stone-path-remnants.cf65f213.png";